<template>
	<div class="bar horse" :style="barStyle">
		<h4>{{ horse.name }}</h4>
		<div v-if="Array.isArray(tasks)" class="tasks">
			<ul :style="taskContainerStyle">
				<li v-for="task in assignedTasks" :key="task.id" :title="task.name">{{ task.abbreviation }}</li>
			</ul>
			<button @click="$emit('assignTasks', { horse, tasks })"><i class="ss-plus ss-glyphish-filled"></i></button>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	props: ['horse', 'tasks'],
	computed : {
		...mapState({
			age: state => state.age.list,
			taskList: state => state.tasks.list
		}),
		barStyle() {
			let style = {}

			if(this.horse.ring_worm) {
				style['border-color'] = '#F7402D'
			} else if(this.age.length && this.age[this.horse.age_year - 1]) {
				style['border-color'] = this.age[this.horse.age_year - 1].colour
			}

			return style
		},
		taskContainerStyle() {
			return {
				'width': (this.tasks.length * 14) + 'px'
			}
		},
		assignedTasks() {
			return this.taskList.filter(task => {
				return this.tasks.includes(task.id.toString())
			})
		}
	}
}
</script>

<style lang="scss">
@import "../../scss/mixins.scss";

.bar.horse {
	position: relative;
	background: #E2E3E4;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	border-left: 13px solid #000;
	color: rgb(153, 155, 156);
	h4 {
		color: black;
		align-self: stretch;
		font-weight: 600 !important;
		margin-top: 0px;
		margin-bottom: 0px;
		font-size: 14px;
		line-height: 32px;
		font-weight: 400;
		margin-left: 10px;
	}
	.tasks {
		display: flex;
		flex-direction: row;
		ul {
			padding: 0;
			margin-top: 0px;
			text-align: right;
			list-style: none;
			li {
				display: inline-block;
				background: #fff;
				padding: 4px;
				height: 18px;
				font-size: 10px;
				line-height: 12px;
				margin: 4px;
				@include border-radius(2px);
			}
		}
		button {
			background: transparent;
			border: none;
			line-height: 32px;
			position: relative;
			margin: 0;
			width: 22px;
			i {
				font-size: 14px;
				position: absolute;
				top: 3px;
				right: 5px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Common/Horse.vue